(function () {
  'use strict';

  window.Shopify = window.Shopify || {};
  if (!window.Shopify.formatMoney) {
    window.Shopify.formatMoney = function (cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || window.Shopify.money_format || '${{amount}}';
      function defaultOption(opt, def) { return typeof opt === 'undefined' ? def : opt; }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        var cents2 = parts[1] ? decimal + parts[1] : '';
        return dollars + cents2;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return formatString.replace(placeholderRegex, value);
    };
  }

  /* ---------------------------------------------------------------------
   * Utilidades
   * ------------------------------------------------------------------- */
  function lsGet(key, fallback) {
    try {
      var v = localStorage.getItem(key);
      return v ? JSON.parse(v) : fallback;
    } catch (e) {
      return fallback;
    }
  }
  function lsSet(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vl-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  /* ---------------------------------------------------------------------
   * Reveals al hacer scroll
   * ------------------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.vl-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay') || 0;
          setTimeout(function () { el.classList.add('vl-visible'); }, Number(delay));
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
   * Cifras animadas (count-up)
   * ------------------------------------------------------------------- */
  function initCountUp() {
    var els = document.querySelectorAll('.vl-count-up');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-target') || el.textContent) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = val.toLocaleString('es-AR') + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
   * Header sticky con efecto vidrio al hacer scroll
   * ------------------------------------------------------------------- */
  function initStickyHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 40) header.classList.add('vl-header--scrolled');
      else header.classList.remove('vl-header--scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------------
   * Wishlist (localStorage)
   * ------------------------------------------------------------------- */
  var WISH_KEY = 'vl_wishlist';
  function getWishlist() { return lsGet(WISH_KEY, []); }
  function setWishlist(list) { lsSet(WISH_KEY, list); updateWishlistCount(); }
  function isWished(handle) { return getWishlist().indexOf(handle) > -1; }
  function toggleWish(handle, btn) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
      if (btn) btn.classList.remove('is-active');
      toast('Se quitó de tu lista de deseos');
    } else {
      list.push(handle);
      if (btn) btn.classList.add('is-active');
      toast('Añadido a tu lista de deseos');
    }
    setWishlist(list);
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-vl-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function initWishlistButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vl-wish-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-vl-wish-toggle');
      toggleWish(handle, btn);
    });
    document.querySelectorAll('[data-vl-wish-toggle]').forEach(function (btn) {
      if (isWished(btn.getAttribute('data-vl-wish-toggle'))) btn.classList.add('is-active');
    });
    updateWishlistCount();
  }

  /* ---------------------------------------------------------------------
   * Vistos recientemente
   * ------------------------------------------------------------------- */
  var RECENT_KEY = 'vl_recently_viewed';
  function trackRecentlyViewed() {
    var handle = document.body.getAttribute('data-vl-product-handle');
    if (!handle) return;
    var list = lsGet(RECENT_KEY, []);
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 8);
    lsSet(RECENT_KEY, list);
  }

  /* ---------------------------------------------------------------------
   * Comparador de productos
   * ------------------------------------------------------------------- */
  var COMPARE_KEY = 'vl_compare';
  var COMPARE_MAX = 4;
  function getCompare() { return lsGet(COMPARE_KEY, []); }
  function setCompare(list) { lsSet(COMPARE_KEY, list); renderCompareBar(); }
  function isComparing(handle) { return getCompare().some(function (p) { return p.handle === handle; }); }
  function toggleCompare(data) {
    var list = getCompare();
    var idx = list.findIndex(function (p) { return p.handle === data.handle; });
    if (idx > -1) {
      list.splice(idx, 1);
      toast('Se quitó del comparador');
    } else {
      if (list.length >= COMPARE_MAX) {
        toast('Podés comparar hasta ' + COMPARE_MAX + ' productos');
        return;
      }
      list.push(data);
      toast('Añadido al comparador');
    }
    setCompare(list);
  }
  function renderCompareBar() {
    var bar = document.querySelector('[data-vl-compare-bar]');
    if (!bar) return;
    var list = getCompare();
    var thumbs = bar.querySelector('[data-vl-compare-thumbs]');
    var countEl = bar.querySelector('[data-vl-compare-count]');
    if (thumbs) {
      thumbs.innerHTML = list.map(function (p) {
        return '<img src="' + p.image + '" alt="' + p.title + '">';
      }).join('');
    }
    if (countEl) countEl.textContent = list.length;
    bar.classList.toggle('is-visible', list.length > 0);
    document.querySelectorAll('[data-vl-compare-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', isComparing(btn.getAttribute('data-handle')));
    });
  }
  function initCompareButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vl-compare-toggle]');
      if (btn) {
        e.preventDefault();
        toggleCompare({
          handle: btn.getAttribute('data-handle'),
          title: btn.getAttribute('data-title'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          url: btn.getAttribute('data-url')
        });
        return;
      }
      var clearBtn = e.target.closest('[data-vl-compare-clear]');
      if (clearBtn) { e.preventDefault(); setCompare([]); }
      var goBtn = e.target.closest('[data-vl-compare-go]');
      if (goBtn) {
        e.preventDefault();
        var handles = getCompare().map(function (p) { return p.handle; }).join(',');
        window.location.href = '/pages/comparador?items=' + encodeURIComponent(handles);
      }
    });
    renderCompareBar();
  }

  /* ---------------------------------------------------------------------
   * Chat de soporte (respuestas por coincidencia de palabras clave)
   * ------------------------------------------------------------------- */
  function initChat() {
    var fab = document.querySelector('[data-vl-chat-fab]');
    var panel = document.querySelector('[data-vl-chat-panel]');
    if (!fab || !panel) return;
    var body = panel.querySelector('[data-vl-chat-body]');
    var form = panel.querySelector('[data-vl-chat-form]');
    var input = panel.querySelector('[data-vl-chat-input]');

    var faq = [];
    try { faq = JSON.parse(panel.getAttribute('data-vl-chat-faq') || '[]'); } catch (e) {}

    function addMsg(text, who) {
      var el = document.createElement('div');
      el.className = 'vl-chat-msg' + (who === 'user' ? ' vl-chat-msg--user' : '');
      el.textContent = text;
      body.appendChild(el);
      body.scrollTop = body.scrollHeight;
    }

    function respond(msg) {
      var lower = msg.toLowerCase();
      var best = null, bestScore = 0;
      faq.forEach(function (item) {
        var kws = (item.keywords || '').toLowerCase().split(',').map(function (k) { return k.trim(); }).filter(Boolean);
        var score = kws.reduce(function (acc, kw) { return acc + (kw && lower.indexOf(kw) > -1 ? 1 : 0); }, 0);
        if (score > bestScore) { bestScore = score; best = item; }
      });
      var reply = best ? best.answer : (panel.getAttribute('data-vl-chat-fallback') || 'Gracias por tu mensaje. Un asesor te va a responder a la brevedad. Mientras tanto, podés escribirnos por WhatsApp para atención inmediata.');
      setTimeout(function () { addMsg(reply, 'bot'); }, 500);
    }

    fab.addEventListener('click', function () { panel.classList.toggle('is-open'); });
    var closeBtn = panel.querySelector('[data-vl-chat-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { panel.classList.remove('is-open'); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = (input.value || '').trim();
        if (!val) return;
        addMsg(val, 'user');
        input.value = '';
        respond(val);
      });
    }
  }

  /* ---------------------------------------------------------------------
   * Carrusel infinito de productos: scroll real continuo (compatible con
   * arrastre táctil/mouse), se pausa al interactuar y retoma solo.
   * El contenido se duplica en Liquid para poder resetear sin salto.
   * ------------------------------------------------------------------- */
  function initInfiniteCarousels() {
    document.querySelectorAll('[data-vl-infinite-track]').forEach(function (track) {
      var speed = parseFloat(track.getAttribute('data-vl-speed') || '0.5');
      var isDown = false, startX = 0, scrollStart = 0, moved = false, paused = false, resumeTimer = null;
      var half = track.scrollWidth / 2;

      function frame() {
        if (!isDown && !paused) {
          track.scrollLeft += speed;
          if (track.scrollLeft >= half) track.scrollLeft -= half;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });

      // El arrastre manual (drag-to-scroll) es SOLO para mouse/lápiz: en touch
      // capturar el puntero rompe el scroll nativo de la página (el dedo queda
      // "atrapado" en el carrusel). En touch dejamos que el navegador maneje
      // el scroll táctil de forma nativa (el track ya es overflow-x:auto).
      var touchStartX = 0, touchStartY = 0, touchTarget = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') {
          paused = true;
          touchStartX = e.clientX;
          touchStartY = e.clientY;
          touchTarget = e.target;
          return;
        }
        isDown = true; moved = false;
        startX = e.clientX;
        scrollStart = track.scrollLeft;
        clearTimeout(resumeTimer);
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch' || !isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        var next = scrollStart - dx;
        if (next < 0) next += half;
        if (next >= half) next -= half;
        track.scrollLeft = next;
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        track.addEventListener(evt, function (e) {
          isDown = false;
          if (e.pointerType === 'touch') {
            resumeTimer = setTimeout(function () { paused = false; }, 800);
            // El carrusel se mueve solo todo el tiempo: un navegador puede
            // confundir un toque limpio con un gesto de scroll y "tragarse"
            // el click. Si el dedo casi no se movió, navegamos a mano.
            if (evt === 'pointerup' && touchTarget) {
              var dx = Math.abs(e.clientX - touchStartX);
              var dy = Math.abs(e.clientY - touchStartY);
              if (dx < 8 && dy < 8) {
                var link = touchTarget.closest ? touchTarget.closest('a[href]') : null;
                if (link) {
                  var href = link.getAttribute('href');
                  setTimeout(function () { window.location.href = href; }, 0);
                }
              }
            }
            touchTarget = null;
            return;
          }
          resumeTimer = setTimeout(function () {}, 400);
        });
      });
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ---------------------------------------------------------------------
   * Barra sticky de compra (mobile) — aparece cuando el botón principal sale de vista
   * ------------------------------------------------------------------- */
  function initStickyBuyBar() {
    var bar = document.querySelector('[data-vl-sticky-buy]');
    var trigger = document.querySelector('[data-vl-add-btn]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(trigger);

    var barForm = bar.querySelector('[data-vl-sticky-buy-btn]');
    if (barForm) {
      barForm.addEventListener('click', function (e) {
        e.preventDefault();
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------------------------------------------------------------------
   * Init
   * ------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCountUp();
    initStickyHeader();
    initWishlistButtons();
    initCompareButtons();
    trackRecentlyViewed();
    initChat();
    initInfiniteCarousels();
    initStickyBuyBar();
  });
})();
